export default "__VITE_ASSET__xWyE6pFy__"